module.exports = __webpack_public_path__ + "assets/img/addTask_btn2.3a1ad598.png";